import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { MapPin } from "lucide-react";

export default function CitiesPage() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 lg:px-6 py-14">
      <Seo title="Browse by city" canonicalPath="/cities" />
      <h1 className="font-display text-3xl md:text-4xl font-bold">Browse by city</h1>
      <p className="text-muted-foreground mt-2 max-w-2xl">
        We're starting with Pune and rolling out to more cities across India soon.
      </p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-8">
        <Link to="/doctors/pune" className="rounded-xl border border-border p-6 card-hover bg-card">
          <span className="h-11 w-11 rounded-xl bg-primary/10 text-primary grid place-items-center"><MapPin size={22} /></span>
          <h3 className="font-display text-xl font-semibold mt-4">Pune</h3>
          <p className="text-sm text-muted-foreground mt-1">Maharashtra · Browse verified clinics across 15+ areas.</p>
        </Link>
        {["Mumbai", "Bengaluru", "Delhi NCR", "Hyderabad", "Chennai", "Kolkata"].map((c) => (
          <div key={c} className="rounded-xl border border-dashed border-border p-6 bg-muted/40">
            <h3 className="font-display text-xl font-semibold text-muted-foreground">{c}</h3>
            <p className="text-sm text-muted-foreground mt-1">Coming soon</p>
          </div>
        ))}
      </div>
    </section>
  );
}
